<template>
  <li>
    <a
      v-if="hasChild==='false'"
      tabindex="0"
      @click="goTo(menuLink)"
      @keydown="onKeyDown($event, menuLink)">{{ menuText }}</a>
    <button
      v-else
      :aria-expanded="expanded"
      class="utility-dropdown--small"
      @click="handleCaretClick"
      @keydown="handleKeyDown"
    >
      {{ menuText }}
      <span
        :class="{'caret close': !isOpen, 'caret open': isOpen}"
      />
    </button>

    <transition name="utility-slide">
      <ul
        v-show="isOpen"
        :aria-hidden="isOpen ? 'false' : 'true'"
        class="sub-menu">
        <li
          v-for="(childMenu, index) in childMenus"
          :key="index">
          <a
            :href="childMenu.href"

            @blur="handleMouseOutInChild(index)"
            @click="goTo(childMenu.href)"
            @keydown="onKeyDown($event, childMenu.href)"
          >{{ childMenu.text }}</a>
        </li>
      </ul>
    </transition>
  </li>
</template>

<script>
import eventBus from '../../../js/util/eventBus'

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    menuText: {
      type: String,
      default: 'Menu',
    },
    menuLink: {
      type: String,
      default: '/',
    },
    hasChild: {
      type: String,
      default: 'false',
    },
    childLinks: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showMenu: false,
      isOpen: false,
    }
  },

  computed: {
    expanded() {
      const open = this.isOpen ? 'true' : 'false'
      return this.hasChild === 'true' ? open : false
    },
    childMenus() {
      if (this.childLinks === '') {
        return []
      }

      return JSON.parse(this.childLinks)
    },
    isMobile() {
      return window.innerWidth < 1024
    },
  },

  created() {
    eventBus.$on('click:main:menu', this.onClickMenu)
    eventBus.$on('toggle:menu', this.onToggleMenu)
    eventBus.$on('select:menu:last', this.selectLastMenu)
  },

  methods: {
    handleCaretClick() {
      // event.preventDefault()
      this.isOpen = !this.isOpen
      eventBus.$emit('click:utility:menu', this.id)
    },

    handleMouseOutInChild(index) {
      if (index === this.childMenus.length - 1 && this.isMobile) {
        this.onToggleMenu()
        this.$el.firstChild.focus()
      } else if (index === this.childMenus.length - 1 && !this.isMobile) {
        eventBus.$emit('select:trigger')
      } else if ((event.code === 'ArrowDown')) {
        event.preventDefault()
        // console.log(this.$el.children[1].children[index + 1].firstChild)

        if (index === this.childMenus.length - 1) {
          // this.onToggleMenu()

          this.$el.children[1].children[0].firstChild.focus()
          return
        }

        this.$el.children[1].children[index + 1].firstChild.focus()
      } else if ((event.code === 'ArrowUp')) {
        event.preventDefault()
        // console.log(this.$el.children[1].children[index + 1].firstChild)
        // console.log(index)
        if (index === 0) {
          // this.onToggleMenu()
          // console.log(this.$el.children[1].lastElementChild)
          this.$el.children[1].lastElementChild.firstChild.focus()
        } else {
          this.$el.children[1].children[index - 1].firstChild.focus()
        }
      }
    },

    onClickMenu(activeMenuData) {
      if (!activeMenuData) {
        this.isActive = true
        return
      }
      if (activeMenuData.menuId === this.id) {
        this.isActive = true
      } else {
        this.isActive = false
      }
    },

    handleKeyDown(event) {
      if (!this.isOpen && this.isMobile &&
        event.key === 'Tab' && !event.shiftKey) {
        event.preventDefault()
        eventBus.$emit('select:trigger')
        eventBus.$emit('toggle:menu', false)
      }
    },

    selectLastMenu() {
      if (this.isOpen && this.isMobile) {
        this.$el.lastChild.lastChild.firstChild.focus()
      } else if (!this.isOpen && this.isMobile) {
        this.$el.firstChild.focus()
      }
    },

    onToggleMenu() {
      this.isOpen = false
      this.showMenu = false
    },

    goTo(menuLink) {
      window.location.href = menuLink
    },

    onKeyDown(event, menuLink) {
      if (event.key === 'Enter') {
        window.location.href = menuLink
      }
    },
  },
}
</script>
